import React, { Component } from 'react';
import { Helmet } from 'react-helmet';

import Heading from './Heading';
import WhyBB from './WhyBB';
import InsuranceProds from './InsuranceProds';
import TargetClients from './TargetClients';
import Partners from './Partners';
import Reviews from './Reviews';
import Signup from './Signup';
import Contact from './Contact';
import LicStates from './LicStates';

class Home extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>BeemaBroker: The Millennial Insurance Broker</title>
          <meta name='description' content='BeemaBroker: Millennial Insurane Broker. Request access to our private beta.'/>
        </Helmet>

        <Heading />
        <Signup />
        <LicStates />
        <InsuranceProds />
        <Partners />
        <TargetClients />
        <WhyBB />
        <Contact />
        <Reviews />
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/js/Home/Home.js